<template>
  <v-container fluid class="container d-flex h-100 justify-center align-center">
    <div class="login-form d-flex flex-column pa-8 rounded-lg">
      <p class="login-form__title">로그인</p>
      <v-spacer></v-spacer>
      <v-text-field v-model="account" class="flex-0-0" placeholder="아이디" hide-details @keyup.enter="$refs.$password.focus()"></v-text-field>
      <v-text-field ref="$password" v-model="password" class="mt-10 flex-0-0" placeholder="비밀번호" hide-details type="password" @keyup.enter="onLogin"></v-text-field>
      <v-btn class="mt-10" size="large" color="primary" variant="flat" :loading="waitForLogin" @click="onLogin">로그인</v-btn>
    </div>
  </v-container>
</template>

<script setup>
import {inject, onMounted, reactive, ref} from 'vue';
import {useRoute, useRouter} from "vue-router";
import {useAppStore} from "@/stores/app";
import {useSessionStore} from "@/stores/session";

const axios = inject('axios');
const router = useRouter();
const appStore = useAppStore();
const sessionStore = useSessionStore();

const account = ref('');
const password = ref('');
const waitForLogin = ref(false);
// const account = ref('keepers');
// const password = ref('qwe123!@#');

const dialog = reactive({
  signUp: {
    visible: false,
  },
  inform: {
    visible: false,
  }
});

const apiError = async response => {
  if (200 !== response.status) return;

  const apiResponse = response.data;
  if (1000 === apiResponse.code) return alert('아이디나 비밀번호를 확인해주세요');
  if (0 !== apiResponse.code) return alert(apiResponse.message);

  return apiResponse;
};

const onLogin = async () => {
  waitForLogin.value = true;
  try {
    const response = await apiError(await axios.post('/api/auth/signin', {
      account: account.value,
      password: password.value,
    }));
    if (!response) {
      waitForLogin.value = false;
      return;
    }

    sessionStore.profile.name = response.response.name;
    sessionStore.profile.account = response.response.account;
    sessionStore.profile.repr = response.response.repr;
    sessionStore.profile.admin = response.response.admin;
    sessionStore.authorized = true;

    appStore.clear();
    await appStore.loadDevices();
    await appStore.loadRemocons();

    await router.push({path: '/'});

  } catch (error) {
    console.log(error);
  }
  waitForLogin.value = false;
};

const openSignUp = () => {
  dialog.signUp = {
    visible: true,
    name: '',
    email: '',
    password: '',
    repassword: '',
  };
};

const onSignUp = async () => {
  const name = dialog.signUp.name.trim();
  const email = dialog.signUp.email.trim();
  const password = dialog.signUp.password;
  const repassword = dialog.signUp.repassword;

  if (!name) {
    await new Promise(r => dialog.inform = {visible: true, title: '회원가입', message: '이름을 입력하세요.', onOk: r});
    dialog.inform.visible = false;
    return;

  } else if (!email) {
    await new Promise(r => dialog.inform = {visible: true, title: '회원가입', message: '이메일을 입력하세요.', onOk: r});
    dialog.inform.visible = false;
    return;

  } else if (!password) {
    await new Promise(r => dialog.inform = {visible: true, title: '회원가입', message: '비밀번호를 입력하세요.', onOk: r});
    dialog.inform.visible = false;
    return;

  } else if (password !== repassword) {
    await new Promise(r => dialog.inform = {visible: true, title: '회원가입', message: '비밀번호가 일치하지 않습니다.', onOk: r});
    dialog.inform.visible = false;
    return;
  }

  try {
    const response = await apiError(await axios.post('/api/auth/signup', {name, email, password}));
    if (!response || 0 !== response.code) return;

    await new Promise(r => dialog.inform = {visible: true, title: '회원가입', message: '회원에 가입되었습니다.', onOk: r});
    dialog.inform.visible = false;
    dialog.signUp.visible = false;
    await router.push({name: 'Login'});

  } catch (error) {
    console.log(error);
  }
};

</script>

<style scoped>

.container {
  background: url('@/assets/login-bg.jpg') no-repeat center center;
  background-size: cover;
}

.login-form {
  min-width: 400px;
  min-height: 400px;
  background-color: white;
  backdrop-filter: blur(24px);
}

.login-form__title {
  font-size: 1.4rem;
}

</style>
